import { useMemo } from "react";
import { styled } from "styled-components";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { chevron } from "../icons/index.js";
import { mobileBreakPointCSS } from "../defaults/theme.js";

interface Crumb {
  url: string;
  label: string;
}

export const Breadcrumbs: React.FunctionComponent = () => {
  const store = useStore();

  const crumbs = useMemo<Crumb[]>(() => {
    const page = store.context.page;

    return page.parents
      .map((p) => ({
        url: p.url,
        label: p.title,
      }))
      .concat([
        {
          url: page.url,
          label: page.title,
        },
      ]);
  }, [store.context.page]);

  const maxWidth = useMemo(
    () => Math.floor(100 / crumbs.length),
    [crumbs.length]
  );

  return (
    <Wrapper>
      <Ul>
        {crumbs.map((c, k) => (
          <Li key={k} $maxWidth={maxWidth}>
            <a href={c.url}>
              <span>{c.label}</span>
              <Caret>{chevron}</Caret>
            </a>
          </Li>
        ))}
      </Ul>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media (max-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.s};
  }
`;

const Ul = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: ${(props) => props.theme.spacing.xs};

  li:last-child i {
    display: none;
  }
`;

const Li = styled.li<{ $maxWidth: number }>`
  display: flex;
  align-items: center;
  max-width: ${(props) => props.$maxWidth}%;

  a {
    display: flex;
    align-items: center;
    color: var(--swatch2);
    text-decoration: none;
    max-width: 100%;

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Caret = styled.i`
  display: inline-flex;
  margin-left: ${(props) => props.theme.spacing.xs};

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: var(--swatch2);
    }
  }

  @media (max-width: ${mobileBreakPointCSS}) {
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
